// Handle confuse targeting
const targetConfuse = (targetZone, targetIndex, ws, setError, setConfuseTargetMode, setSelectedConfuseWeaponId) => {
  if (!ws || ws.readyState !== 1) {
    setError("Connection lost. Please refresh the page.");
    return;
  }

  // Determine if targeting friendly or opponent unit
  let targetUnitId = "friendly";
  let actualTargetZone = targetZone;

  // If targeting opponent zones, use opponent targeting
  if (targetZone === "opponent_front" || targetZone === "opponent_flank") {
    targetUnitId = "opponent";
    actualTargetZone = targetZone;
  }

  // Send confuse targeting action
  const action = {
    type: "targetConfuse", 
    targetUnitId: targetUnitId,
    targetZone: actualTargetZone,
    targetIndex: targetIndex
  };

  ws.send(JSON.stringify(action));
  
  // Reset confuse targeting
  setConfuseTargetMode(false);
  setSelectedConfuseWeaponId(null);
};

export default targetConfuse;
